export default "__VITE_ASSET__DcoMlKdY__"